<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6">
          <v-toolbar color="secondary" dark shaped>
            <h3 class="title">Gerar Relatório Analítico:</h3>
          </v-toolbar>
          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col cols="12" sm="12" md="3">
                  <Date
                    @dateValue="[(itemNewValues.startDate = $event)]"
                    label="Data Inicial"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="3">
                  <Date
                    @dateValue="[(itemNewValues.endDate = $event)]"
                    label="Data Final"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    v-model="itemNewValues.prefecture_id"
                    label="Prefeitura"
                    :items="prefectures"
                    item-text="prefecture_social_name"
                    item-value="prefecture_id"
                    clearable
                    :readonly="formDisable"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <br />
          <v-footer absolute rounded>
            <v-btn text :loading="loader"></v-btn>
            <v-spacer />
            <v-btn
              color="secondary"
              class="mr-2"
              text
              :to="`/parts-and-services/report/analytical/${itemNewValues.prefecture_id}/${itemNewValues.startDate}/${itemNewValues.endDate}`"
              :disabled="
                itemNewValues.prefecture_id &&
                itemNewValues.startDate &&
                itemNewValues.endDate
                  ? false
                  : true
              "
            >
              Gerar Relatório
            </v-btn>
          </v-footer>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar
      multi-line
      :color="snack.color"
      v-model="snack.show"
      transition="fade-transition"
    >
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Date from "@/components/InputDate.vue";
import Helpers from "@/mixins/helpers";
export default {
  components: { Date },
  mixins: [Helpers],
  data: () => ({
    prefectures: [],
    itemNewValues: {
      prefecture_id: null,
      startDate: null,
      endDate: null,
    },
    loader: false,
    snack: {
      show: false,
      message: "",
      color: "",
    },
    formDisable: false,
  }),
  created() {
    this.Helpers;
    this.loader = true;
    this.$store.dispatch("setLoader", this.loader);
    this.$http.get(`/prefectures`).then((r) => {
      this.prefectures = r.data;
      this.loader = false;
      this.$store.dispatch("setLoader", this.loader);
    });
    if (this.$store.getters.getUserData.table_key == 'prefectures') {
      this.formDisable = true;
      this.itemNewValues.prefecture_id = this.$store.getters.getUserData.table_id;
    }
  },
  methods: {
    emptyValues() {
      this.itemNewValues.prefecture_id = null;
      this.itemNewValues.startDate = null;
      this.itemNewValues.endDate = null;
    },
  },
};
</script>

<style>
</style>